import { useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { useGoPage } from "../../hooks/useGoPage";
import { useFormatText } from '../../hooks/useFormatText';
import { LangContext } from "../../context/LangContext";

import SelectLang from "../../components/SelectLang";
import Slider from '../../components/Slider';
import Gallery from '../../components/Gallery';
import TooltipPortal from "../../components/TooltipPortal";

import "./style.css"

import btn_amazon from '../../assets/img/amazon.png'
import award_icon from '../../assets/svg/laurel_wreath.svg';

function Work({ work }) {
    const awardRefs = useRef({});
    const goPage = useGoPage();
    const formatText = useFormatText();
    const [logoStyle, setLogoStyle] = useState(null);
    const [activeTooltip, setActiveTooltip] = useState(null);
    const { language, translations } = useContext(LangContext);
    const headerWidth = useSelector(state => state.options.headerWidth);

    const _return = () => {
        const opt_return = localStorage.getItem('opt_return_work_pg_vanrah');

        if (opt_return === 'vanrah') goPage('');
        else goPage(work.type === 1 ? 'mangas' : 'works');
    }

    useEffect(() => {
        if (!work?.logo?.url) {
            setLogoStyle(null)
            return;
        }

        const img = new Image();
        img.src = work.logo.url;

        img.onload = () => {
            // height
            if (img.naturalWidth < img.naturalHeight) {
                setLogoStyle({
                    height: headerWidth < 700 ? '180px' : '340px',
                    aspectRatio: `${img.naturalWidth} / ${img.naturalHeight}`,
                    backgroundImage: `url(${work.logo.url})`
                });
            }
            // width
            else {
                setLogoStyle({
                    width: '100%',
                    aspectRatio: `${img.naturalWidth} / ${img.naturalHeight}`,
                    backgroundImage: `url(${work.logo.url})`
                });
            }
        };
    }, [headerWidth, work]);

    return work && (
        <div className='page page_work'>
            <button className="btn_return" onClick={() => _return()}>
                {'<'}- <span>{translations.return}</span> --
            </button>

            <SelectLang />

            {logoStyle && headerWidth < 700 &&
                <div className="logo_work">
                    <i style={logoStyle}></i>
                </div>
            }

            {work[`awards_${language}`].length !== 0 &&
                <div className="awards">
                    <img
                        src={award_icon}
                        alt="Award(s)"

                        ref={el => awardRefs.current[0] = el}
                        onMouseEnter={() => setActiveTooltip(0)}
                        onMouseLeave={() => setActiveTooltip(null)}
                    />

                    <TooltipPortal
                        targetRef={{ current: awardRefs.current[0] }}
                        show={activeTooltip === 0}
                    >
                        {work[`awards_${language}`].map((award, id) => (
                            <li key={id}>{award}</li>
                        ))}
                    </TooltipPortal>
                </div>
            }

            <section className="sect_presentation">
                <div className="container_slider_and_btn_amazon">
                    <Slider images={work.images} />

                    {work.amazon && headerWidth > 700 &&
                        <a className="btn_amazon_desktop" href={work.amazon} target="blank">
                            <img src={btn_amazon} alt="Buy to amazon" />
                        </a>
                    }
                </div>

                <div className="description">
                    {logoStyle && headerWidth > 700 &&
                        <div className="logo_work">
                            <i style={logoStyle}></i>
                        </div>
                    }

                    <div className="fields">
                        <div className="textarea">
                            <span className="label">{translations.detail_and_descrip} :</span>
                            <p className="value">{formatText(work[`descrip_${language}`])}</p>
                        </div>

                        {work.editor && <p className="field"><span>{translations.editor} :</span>{work.editor}</p>}
                        {work.pg && <p className="field"><span>{translations.pegi} :</span>{work.pg}</p>}
                        {work.genre && <p className="field"><span>{translations.genre} :</span>{work.genre}</p>}

                        {work[`theme_${language}`] && <p className="field"><span>{translations.theme} :</span>{work[`theme_${language}`]}</p>}

                        {work.in_progress ?
                            <p className="field">
                                <span>{translations.ongoing_series} :</span>
                                {work.in_progress}
                            </p> :
                            <p className="field">
                                <span>{translations.upcoming_series}</span>
                            </p>
                        }

                        {work.patreon && <a className="link" href={work.patreon} target='blank'>{translations.read_online}</a>}
                        {work.chapiter && <a className="link" href={work.chapiter} target='blank'>{translations.read_first_chapter}</a>}

                        {work.amazon && headerWidth < 700 &&
                            <a className="btn_amazon_mobile" href={work.amazon} target="blank">
                                <img src={btn_amazon} alt="Buy to amazon" />
                            </a>
                        }
                    </div>
                </div>
            </section>

            {work.video &&
                <section className="sect_video">
                    <p className="subtitle_page">
                        - <span>Trailer</span> -
                    </p>

                    <div className="video">
                        <iframe
                            title="video"
                            src={work.video}

                            width="100%"
                            height="100%"

                            frameBorder="0"
                            allowFullScreen
                        ></iframe>
                    </div>
                </section>
            }

            {work.gallery && work.gallery.length !== 0 &&
                <section className="sect_gallery">
                    <p className="subtitle_page">
                        - <span>{translations.gallery}</span> -
                    </p>

                    <Gallery gallery={work.gallery} />
                </section>
            }
        </div>
    )
}

export default Work;